import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "toggle"
}
const _hoisted_2 = { class: "toggle__checkboxes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_checkbox, {
            color: _ctx.color,
            label: _ctx.label,
            modelValue: _ctx.selected,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(() => {_ctx.selected = !_ctx.selected; _ctx.onChange();}, ["enter"])),
            onChange: _ctx.onChange,
            "hide-details": ""
          }, null, 8, ["color", "label", "modelValue", "onChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}